@use '../@shared/mixins' as *;
@use '../../../assets/kolicons/style' as *;

@layer kol-component {
	/* :host implicitly inherits font-size, see below */
	:host {
		color: inherit;
		display: contents;

		font-size: inherit;
		font-weight: inherit;
		line-height: inherit;
	}
}
